import React, { useEffect, useState } from "react";
import { Form, Button, Row, FloatingLabel, Col } from "react-bootstrap";
import Feedback from "react-bootstrap/esm/Feedback";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLocalizedRoutes } from "../../../hooks/useLocalizedRoutes";
import { ValidateToken } from "../../../helpers/validateToken";
import { startLogout } from "../../../store/auth";
import file_download from "../../../assets/images/download-pdf-icon.svg";
import { toast } from "react-toastify";
import { LogoPetroprix } from "../../ui/LogoPetroprix";

// creating functional component ans getting props from app.js and destucturing them
export const SaldoStep = ({ nextStep, handleFormData, values, saldos }) => {
  const [validated, setValidated] = useState(false);
  // const { flotaActiva } = useSelector((state) => state.auth);
  const [fileToUpload, setFileToUpload] = useState({ base64: "", name: "" });
  const [validatingFile, setValidatingFile] = useState(false);
  const [saldoFuturo, setSaldoFuturo] = useState(saldos?.saldoRestante ?? "-");
  const [cantidadSaldo, setCantidadSaldo] = useState(1);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { getPath } = useLocalizedRoutes();

  useEffect(() => {
    const current = parseFloat(saldos?.saldoRestante) || 0;
    const sum = current + parseInt(cantidadSaldo);
    setSaldoFuturo(sum);
  }, [cantidadSaldo, saldos]);

  // after form submit validating the form data using validator
  const submitFormData = async (e) => {
    e.preventDefault();
    setValidated(false);

    const importe = document.getElementById("flotas-agregar-saldo-importe");

    let dataValid = {
      flota: false,
      importe: false,
    };

    if (
      importe.value === "" ||
      importe.value < 1 ||
      isNaN(importe.value) ||
      importe.value > 3000
    ) {
      importe.setCustomValidity(" ");
      dataValid.importe = false;
    } else {
      importe.setCustomValidity("");
      dataValid.importe = true;
    }

    setValidated(true);

    if (!dataValid.importe) {
      return;
    } else {
      // values.flota_id = flotaActiva.id_cuenta;
      // values.flota_nombre = flotaActiva.nombre_cuenta;
      values.importe = importe.value;

      nextStep();
    }
  };

  const navigate = useNavigate();

  const handleGoBack = () => {
    if (ValidateToken()) {
      navigate(getPath('fleetsMyFleets'));
    } else {
      dispatch(startLogout("expired"));
    }
  };

  useEffect(() => {}, [saldos]);

  const uploadJustificante = (event) => {
    const file = event.target.files[0];

    if (
      file &&
      ["application/pdf", "image/jpeg", "image/png"].includes(file.type)
    ) {
      const reader = new FileReader();

      // Read the file as a data URL
      reader.readAsDataURL(file);

      reader.onload = () => {
        const base64 = reader.result.split(",")[1]; // Get the Base64 part
        setFileToUpload({ base64: base64, name: file.name });
      };

      reader.onerror = (error) => {
        console.error("Error reading file:", error);
        toast("Error leyendo el fichero", { icon: <LogoPetroprix /> });
      };
    } else {
      toast("Solo se permiten archivos PDF, JPG o PNG", {
        icon: <LogoPetroprix />,
      });
    }
  };

  return (
    <>
      <Form
        className="flotas-agregar-saldo-form mt-2"
        autoComplete="off"
        onSubmit={(e) => submitFormData(e)}
        noValidate
        validated={validated}
      >
        <Row>
          {/* Top cards: saldo actual y saldo futuro */}
          <Row className="mb-3">
            <div className="col-md-6 mb-2">
              <div className="card h-100">
                <div className="card-body">
                  <h6 className="card-title mt-2 mb-0">
                    {t("flotas.agregar-saldo.form.saldo-actual")}
                  </h6>
                  <p className="fw-bold" style={{ fontSize: "1.25rem" }}>
                    {saldos?.saldoRestante ?? "-"}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-2">
              <div className="card h-100">
                <div className="card-body">
                  <h6 className="card-title mt-2 mb-0">
                    {t("flotas.agregar-saldo.form.saldo-futuro")}
                  </h6>
                  <p
                    id="flotas-agregar-saldo-futuro"
                    className="fw-bold text-primary"
                    style={{ fontSize: "1.5rem" }}
                  >
                    {saldoFuturo}
                  </p>
                </div>
              </div>
            </div>
          </Row>
          <FloatingLabel
            label={t("flotas.agregar-saldo.form.importe")}
            className="mb-3"
            style={{ paddingRight: "2.3em" }}
          >
            <Form.Control
              type="number"
              step="1"
              min="1"
              max="999999"
              value={cantidadSaldo}
              onChange={(e) => {
                const value = e.target.value;
                //Si no es un número, es decimal o es menor que 1, no actualizar
                if (
                  isNaN(value) ||
                  value.includes(".") ||
                  value.includes(",") ||
                  value < 1 ||
                  value > 999999
                ) {
                  return;
                }
                setCantidadSaldo(value);
              }}
              pattern="^[1-9][0-9]{0,5}$"
              id="flotas-agregar-saldo-importe"
            />
            <Feedback type="invalid">
              {t("flotas.agregar-saldo.form.importe.invalid")}
            </Feedback>
          </FloatingLabel>
          {/* <Row>
            <div className="flotas-registro-buttons mt-5">
              <Button
                variant="outline-primary"
                size="lg"
                name="cantidad"
                onClick={handleGoBack}
              >
                {t("flotas.registro-flota.btn-back")}
              </Button>
              <Button variant="primary" size="lg" type="submit">
                {t("flotas.registro-flota.btn-next")}
              </Button>
            </div>
          </Row> */}
          <Row style={{ paddingLeft: "1em" }}>
            <Button
              variant="outline-file"
              id="nombre-fichero"
              onClick={() => {}}
              className={"btn-outline-file mt-2 m-2 mb-2"}
              style={{ width: "280px" }}
              disabled={true}
            >
              {fileToUpload.name}
            </Button>
            <label
              htmlFor="upload-document"
              variant="outline-primary-file"
              className="m-2 py-2 btn btn-outline-primary-file btn-sm"
              style={{ width: "280px" }}
            >
              <img src={file_download} alt="" />{" "}
              {t("flotas.table.seleccionar-archivo")} (PDF, JPG, PNG)
            </label>
            <input
              type="file"
              name="document"
              id="upload-document"
              accept="application/pdf,image/jpeg,image/png"
              onChange={uploadJustificante}
            />
          </Row>
        </Row>
        <Row>
          <Col xs={12} className="flotas-registro-buttons mt-3">
            <Button
              variant={"outline-primary"}
              className="flotas-btn-add"
              // disabled={fileToUpload.name.length === 0 ? true : false}
              // onClick={handleUploadFile}
              // style={
              //   validatingFile
              //     ? {
              //         pointerEvents: "none",
              //         backgroundColor: "white",
              //       }
              //     : {}
              // }
            >
              {/* {validatingFile ? (
              <>
                <MiniLoader size="xs" />
                <span style={{ color: "#db0b27" }} className="p-1">
                  {t("flotas.registro-flota.informacion.btn-next.validating")}
                </span>
              </>
            ) : ( */}
              {t("flotas.agregar-saldo.form.btn-enviar")}
              {/* )} */}
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};
